import { useInstagramWizard } from "../../-utils/wizard";

import { DoneScreen } from "./done-screen";
import { FormStep } from "./form-step";
import { SendScreen } from "./send-screen";

export function Instagram() {
	const wizard = useInstagramWizard();
	const { phase, draft, hp, pending, actions } = wizard;

	if (phase === "done") {
		return <DoneScreen draft={draft} />;
	}

	if (phase === "send") {
		return (
			<SendScreen
				hp={hp}
				onHpChange={actions.setHp}
				onBack={actions.goToForm}
				onSubmit={actions.submit}
				pending={pending}
			/>
		);
	}

	return <FormStep wizard={wizard} />;
}
